import { render, staticRenderFns } from "./deliverydetail.vue?vue&type=template&id=0a817973&scoped=true"
import script from "./deliverydetail.vue?vue&type=script&lang=js"
export * from "./deliverydetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a817973",
  null
  
)

export default component.exports